import { useRef } from 'react'
import useHubSpotGenerate from 'hooks/useHubSpotGenerate'
import styles from './Contact.module.scss'
import animationStyles from 'components/common/Animation/Animation.module.scss'
import useElementVisible from 'components/common/Animation/useElementVisible'

type Props = {
  formId: string
}

export const Contact: React.FC<Props> = ({ formId }) => {
  const animeRef = useRef<HTMLDivElement>(null)
  const isVisible = useElementVisible(animeRef, 0.1)

  useHubSpotGenerate('na1', '9395227', `${formId}`, '#sp_hbspt')

  return (
    <section
      id="contact"
      className={`${styles.contact} ${animationStyles.fade} ${isVisible ? animationStyles.fadeOn : ''}`}
      ref={animeRef}
    >
      <div className={styles.inner}>
        <h2 className={styles.ctsTitle}>
          <span className={styles.ctsTitle__sub}>まずはお気軽にご相談ください</span>
        </h2>
        <p className={styles.text}>
          スマホアプリ開発のご検討段階でも構いません。
          <br />
          i3DESIGNは中堅・大手企業のアプリ開発において数多く伴走してきた実績があります。
          <br />
          企画段階のヒアリングから、技術・運用まで包括的にご相談いただけます。
        </p>
        <div className={styles.contactForm}>
          <div className={styles.hubSpot} id="sp_hbspt"></div>
        </div>
      </div>
    </section>
  )
}
